<template>
  <section class="content">
    <div v-if="isUserDashBoard" class="password-popup">
      <div class="password-popup-width">
        <h4 class="heading_pop">Investment Dashboard - {{ userName }}</h4>
        <a class="toggle" v-on:click="closeUserDashBoard">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Layer_1"
            x="0"
            y="0"
            version="1.1"
            viewBox="0 0 29 29"
            xml:space="preserve"
          >
            <path
              fill="none"
              stroke="#706c6c"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              stroke-width="2"
              d="M9.197 19.803L19.803 9.197M9.197 9.197l10.606 10.606"
            />
          </svg>
        </a>
        <div class="table-container">
          <div class="total_investment_wrp">
            <div class="col-md-4">
              <div class="panel">
                <div class="panel-body">
                  <div class="row dash-box">
                    <div class="col-sm-8">
                      <p class="number">
                        {{ investedAmount ? investedAmount : '0' }}
                      </p>
                      <p>Total Investment Amount</p>
                    </div>
                    <div class="col-sm-4">
                      <img
                        src="/static/img/logo-usd.png"
                        alt="Logo"
                        style="margin-left: -19px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="panel">
                <div class="panel-body">
                  <div class="row dash-box">
                    <div class="col-sm-8">
                      <p class="number">
                        {{
                          totalInvestmentAmount ? totalInvestmentAmount : '0'
                        }}
                      </p>
                      <p>Current Investment Value</p>
                    </div>
                    <div
                      class="col-sm-4"
                      v-if="totalInvestmentAmount !== 'No data'"
                    >
                      <img
                        src="/static/img/logo-usd.png"
                        alt="Logo"
                        style="margin-left: -19px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="panel">
                <div class="panel-body">
                  <div class="row dash-box">
                    <div class="col-sm-8">
                      <p
                        class="number"
                        :class="{
                          positive: netProfitAndLoss > 0,
                          negative: netProfitAndLoss < 0,
                        }"
                      >
                        {{ netProfitAndLoss ? netProfitAndLoss : '0' }}
                      </p>
                      <p>Unrealised Profit/Loss</p>
                    </div>
                    <div class="col-sm-4" v-if="netProfitAndLoss !== 'No data'">
                      <img
                        src="/static/img/logo-usd.png"
                        alt="Logo"
                        style="margin-left: -19px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="panel">
                <div class="panel-body">
                  <div class="row dash-box">
                    <div class="col-sm-8">
                      <p
                        class="number"
                        :class="{
                          positive: net_pnl > 0,
                          negative: net_pnl < 0,
                        }"
                      >
                        {{ net_pnl ? net_pnl : '0' }}
                      </p>
                      <p>Net Profilt/Loss</p>
                    </div>

                    <div class="col-sm-4" v-if="net_pnl !== 'No data'">
                      <img
                        src="/static/img/logo-usd.png"
                        alt="Logo"
                        style="margin-left: -19px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="panel">
                <div class="panel-body">
                  <div class="row dash-box">
                    <div class="col-sm-8">
                      <p
                        class="number"
                        :class="{
                          positive: net_profit_percentage > 0,
                          negative: net_profit_percentage < 0,
                        }"
                      >
                        {{
                          net_profit_percentage === 'No data'
                            ? net_profit_percentage
                            : `${net_profit_percentage}%`
                        }}
                      </p>
                      <p>Net Profit/Loss %</p>
                    </div>
                    <div
                      class="col-sm-4"
                      v-if="net_profit_percentage !== 'No data'"
                    >
                      <img
                        src="/static/img/logo-usd.png"
                        alt="Logo"
                        style="margin-left: -19px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="panel">
                <div class="panel-body">
                  <div class="row dash-box">
                    <div class="col-sm-8">
                      <p class="number">
                        {{ withdrawlAmount ? withdrawlAmount : '0' }}
                      </p>
                      <p>Withdrawal Amount</p>
                    </div>
                    <div class="col-sm-4">
                      <img
                        src="/static/img/logo-usd.png"
                        alt="Logo"
                        style="margin-left: -19px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tablewrp">
            <div class="col-md-12">
             <h3 >Investment History</h3>
        <table class="table table-bordered" >
          <thead>
            <tr>
              <th>Date</th>
              <th>Current Investment Value ($)</th>
              <th>Unrealised Profit/Loss ($)</th>
              <th>Net Profit/Loss ($)</th>
              <th>Net Profit/Loss %</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in history_table" v-if='history_table.length >0'>
              <td>
                {{
                  data.createdAt
                    
                }}
              </td>
              <td>
                {{
                  data.current_investment_value
                   
                }}
              </td>
              <td>{{ data.pnl_value ? data.pnl_value : '0' }}</td>
              <td>{{ data.net_pnl ? data.net_pnl : '0' }}</td>
              <td>
                {{
                  data.net_profit_percentage ? `${data.net_profit_percentage}%` : '0'
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <h4 v-if='history_table.length ===0' class="teext">No Investment History Found</h4>
            </div>
          </div>
        </div>
        <!-- <div class="col-sm-12 text-right">

            <button class="btn gradientbt" type="submit" @click="chnagePassword"
              :disabled="!(formstate.$dirty && formstate.$valid && !passwordValidation)">Update Password</button>
          </div> -->
      </div>
    </div>
    <div v-if="isAreaTable" class="password-popup">
      <div class="password-popup-width">
        <h4 class="heading_pop">Update Password</h4>
        <a class="toggle" v-on:click="closeAreaTableModal">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Layer_1"
            x="0"
            y="0"
            version="1.1"
            viewBox="0 0 29 29"
            xml:space="preserve"
          >
            <path
              fill="none"
              stroke="#706c6c"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              stroke-width="2"
              d="M9.197 19.803L19.803 9.197M9.197 9.197l10.606 10.606"
            />
          </svg>
        </a>
        <div class="table-container">
          <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
            <div class="col-sm-12">
              <div class="col-sm-6">
                <validate
                  auto-label
                  class="form-group required-field"
                  :class="fieldClassName(formstate.password)"
                >
                  <label>Password :</label>
                  <input
                    required
                    v-model="password"
                    class="form-control"
                    type="password"
                    name="password"
                    placeholder="Password"
                  />
                  <span
                    @click="togglePasswordVisibility('password')"
                    class="password-toggle-icon"
                  >
                    <i
                      :class="{
                        'fa fa-eye': showPassword,
                        'fa fa-eye-slash': !showPassword,
                      }"
                    ></i>
                  </span>
                  <field-messages
                    name="password"
                    show="$touched || $submitted"
                    class="form-control-feedback"
                  >
                    <div slot="required">This is a required field</div>
                  </field-messages>
                </validate>
              </div>
              <div class="col-sm-6">
                <validate
                  auto-label
                  class="form-group required-field"
                  :class="
                    fieldClassName(
                      formstate.confirmPassword,
                      passwordValidation,
                    )
                  "
                >
                  <label>Confirm Password :</label>
                  <input
                    required
                    v-model="confirmPassword"
                    class="form-control"
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirm Password"
                  />
                  <span
                    @click="togglePasswordVisibility('confirmPassword')"
                    class="password-toggle-icon"
                  >
                    <i
                      :class="{
                        'fa fa-eye': showPassword,
                        'fa fa-eye-slash': !showPassword,
                      }"
                    ></i>
                  </span>
                  <field-messages
                    name="confirmPassword"
                    show="$touched || $submitted"
                    class="form-control-feedback"
                  >
                  </field-messages>
                  <a v-if="passwordValidation" style="color: red;"
                    >Passwords do not match.</a
                  >
                </validate>
              </div>
            </div>
          </vue-form>
        </div>
        <div class="col-sm-12 text-right">
          <button
            class="btn gradientbt"
            type="submit"
            @click="chnagePassword"
            :disabled="
              !(formstate.$dirty && formstate.$valid && !passwordValidation)
            "
          >
            Update Password
          </button>
        </div>
      </div>
    </div>
    <div>
      <div class="box-body">
        <div
          :class="addButtonClass"
          v-permission.if="[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN]"
        >
          <router-link :to="{ name: 'UserCreate' }">
            <button class=" btn gradientbt">Add User</button>
          </router-link>
        </div>
        <div
          class="export-btn"
          v-permission.if="[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN]"
        >
          <button class=" btn gradientbt" v-on:click="exportData">
            Export User
          </button>
        </div>

        <v-server-table
          ref="userTable"
          url
          :limit="5"
          :columns="columns"
          :options="options"
          v-on:row-click="rowClick"
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
          <template slot="passwordChange" slot-scope="props">
            <a
              class="fa fa-edit"
              role="button"
              v-on:click.stop="UpdatePassword(props.row)"
            ></a>
          </template>
          <template slot="action" slot-scope="props">
            <div class="active_wrp">
              <a
                class="fa fa-edit"
                role="button"
                v-on:click.stop="action(props.row)"
              ></a>
            </div>
          </template>
          <!-- <template>
            <div class="form-group col-md-2">
              <select
                @change="applyFilter(custom_filter_select)"
                class="form-control"
              >
                <option v-for="value in custom_filter_options" :key="value">{{value}}</option>
              </select>
            </div>
            <button class="btn btn-default inline" @click="clearFilter('')">clear</button>
          </template> -->
        </v-server-table>
      </div>
    </div>
    <div class="total_investment_wrp">
      <div class="col-md-4">
        <div class="panel">
          <div class="panel-body">
            <div class="row dash-box">
              <div class="col-sm-8">
                <p
                  class="number"
                  :class="{ positive: totalPnL > 0, negative: totalPnL < 0 }"
                >
                  {{ totalPnL ? totalPnL : '0' }}
                </p>

                <!-- <p class="number">{{ "5000000" }}</p> -->
                <p>Net Profit/Loss All Users</p>
              </div>
              <div class="col-sm-4">
                <img
                  src="/static/img/logo-usd.png"
                  alt="Logo"
                  style="margin-left: -1px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { formService, formstate } from '../../../services';
import { eventBus } from '../../../services';
import { USER_ROLES } from '../../../config';
import { ServerTable, Event } from 'vue-tables-2';
import { mapState } from 'vuex';
import { exportService, investmentService } from '../../../services';
import moment from 'moment';
import axios from 'axios';
import Config from '../../../config';
// import XLSX from 'xlsx';

export default {
  name: 'Users',
  data() {
    return {
      userName: '',
      net_pnl: '',
      withdrawlAmount: '',
      net_profit_percentage: '',
      totalInvestmentAmount: '',
      investedAmount: '',
      netProfitAndLoss: '',
      currentValue: '',
      history_table: [],
      formstate: {},
      password: '',
      confirmPassword: '',
      showPassword: false,
      passwordValidtion: false,
      isAreaTable: false,
      isUserDashBoard: false,
      loading: null,
      USER_ROLES: USER_ROLES,
      totalPnL: 0,
      userTable: null,
      columns: [
        'firstName',
        'lastName',
        'invested_amount',
        'current_investment_value',
        'startDate',
        'pnl_value',
        'net_profile',
        'net_pnl',
        'withdrawl_amount',
        'action',
      ], //@rohit removed 'edit'
      options: {
        highlightMatches: true,
        headings: {
          firstName: 'First Name',
          lastName: 'Last Name',
          invested_amount: 'Invested Amount ($)',
          current_investment_value: 'Current Investment Value ($)',
          startDate: 'Start Date',
          pnl_value: 'Unrealised Profit/Loss ($)',
          net_pnl: 'Net Profilt/Loss ($)',
          net_profile: 'Net Profile (%)',
          withdrawl_amount: 'Withdrawl Amount',
          actions: 'Action',
        },
        templates: {
          status(row, query) {
            if (query.isActive == true) {
              return (query.status = 'Active');
            } else {
              return (query.status = 'Inactive');
            }
          },
        },
        perPage: 10,
        sortable: [
          'firstName',
          'lastName',
          'email',
          'invested_amount',
          'current_investment_value',
          'pnl_value',
          'net_pnl',
          'withdrawl_amount',
        ],
        requestFunction: request => {
          const params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          params.invisible = false;
          if (this.user.roleName == 'Super Admin') {
          } else {
            params.invisible = false;
          }
          if (request.orderBy) {
            params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          } else {
            params.$sort = '-isActive';
          }
          if (request.query) {
            params.$term = request.query;
          }
          this.loading = true;
          console.log('Param', params, 'userRepository', this.$userRepository);
          return this.$userRepository.list(params).catch(error => {
            console.error('Users.requestFunction-error:', error);
          });
        },
        responseAdapter: response => {
          let data = [];
          response.data.docs.forEach(element => {
            let details = element;
            const withdrawl_amount =
              element.withdrawl_amount !== undefined
                ? element.withdrawl_amount
                : 0;
            details['net_pnl'] =
              element.current_investment_value !== undefined &&
              element.pnl_value !== undefined &&
              element.invested_amount !== undefined
                ? (
                    element.current_investment_value +
                    withdrawl_amount +
                    Number(element.pnl_value) -
                    element.invested_amount
                  ).toFixed(2)
                : 'NA';
            details['net_profile'] =
              element.current_investment_value !== undefined &&
              element.pnl_value !== undefined &&
              element.invested_amount !== undefined
                ? (
                    ((element.current_investment_value +
                      withdrawl_amount +
                      Number(element.pnl_value) -
                      element.invested_amount) /
                      element.invested_amount) *
                    100
                  ).toFixed(2)
                : 'NA';
            details['invested_amount'] =
              element.invested_amount !== undefined
                ? element.invested_amount
                : 'NA';
            details['withdrawl_amount'] =
              element.withdrawl_amount !== undefined
                ? element.withdrawl_amount
                : 0;
            details['current_investment_value'] =
              element.current_investment_value !== undefined
                ? element.current_investment_value
                : 'NA';
            details['pnl_value'] =
              element.pnl_value !== undefined ? element.pnl_value : 'NA';
            details['startDate'] = element.startDate
              ? moment(element.startDate).format('DD-MM-YYYY')
              : 'NA';
            data.push(details);
          });
          this.loading = false;
          console.log(data);
          return {
            data: data,
            count: response.data.items.total,
          };
        },
        customFilters: [
          {
            name: 'custom_filter',
            callback: function(row, query) {
              //	return row.role[0] == query;
              console.log('sssssss', query);
            },
          },
        ],
        uniqueKey: '_id',
      },
    };
  },
  computed: {
    passwordValidation() {
      return this.password !== this.confirmPassword;
    },
    addButtonClass() {
      if (this.userTable) {
        return this.userTable.count > this.userTable.limit ||
          this.userTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
    ...mapState({
      user: state => state.auth.user,
    }),
  },
  methods: {
    emailValidator: formService.emailValidator,
    fieldClassName: formService.fieldClassName,

    getTotalAmount() {
      let data;
      return investmentService.getTotalAmountAll(data).then(
        response => {
          console.log('getTotalAmount', response);
          this.totalPnL = response.data.total_pnl;
        },
        err => {
          console.log(err);
        },
      );
    },

    chnagePassword() {
      console.log(
        '🚀 ~ file: Users.vue:229 ~ chnagePassword ~ chnagePassword:',
        chnagePassword,
      );
    },

    togglePasswordVisibility(field) {
      this.showPassword = !this.showPassword;
      const inputField = document.querySelector(`input[name=${field}]`);
      if (inputField) {
        inputField.type = this.showPassword ? 'text' : 'password';
      }
    },

    closeAreaTableModal() {
      this.password = '';
      this.confirmPassword = '';
      if (this.isAreaTable) {
        this.isAreaTable = !this.isAreaTable;
      }
    },

    UpdatePassword(data) {
      this.isAreaTable = true;
      console.log('UpdatePassword', data);
    },
    getListPnL(data) {
      let id = data.row._id;
      return investmentService.getListPnLAll(id).then(
        response => {
          this.history_table = [];
          if (response.data === []) {
            this.history_table = [];
          } else {
            response.data.data.forEach(element => {
              this.history_table.push({
                withdrawl_amount: element.withdrawl_amount ?(element.withdrawl_amount).toFixed(2): 0,
                createdAt: moment(element.createdAt).format('DD-MM-YYYY '),
                current_investment_value: (element.current_investment_value).toFixed(2),
                pnl_value: (Number(element.pnl_value)).toFixed(2),
                net_profit_percentage:(element.net_profit_percentage).toFixed(2),
                net_pnl:(element.net_pnl).toFixed(2)
              });
            });
          }
        },
        err => {
          this.loading = false;
        },
      );
    },
    getData(data) {
      this.totalInvestmentAmount = '';
      this.netProfitAndLoss = '';
      this.investedAmount = '';
      this.withdrawlAmount = '';
      this.net_pnl = '';
      this.net_profit_percentage = '';
      this.currentValue = '';
      // this.totalInvestmentAmount = data.row.current_investment_value;
      // this.netProfitAndLoss = data.row.pnl_value;
      // this.investedAmount = data.row.invested_amount;
      // this.net_pnl = data.row.net_pnl;
      // this.withdrawlAmount = data.row.withdrawl_amount;
      // // this.net_profit_percentage = data.row.net_profit_percentage;
      // const intValue = parseInt(this.netProfitAndLoss, 10);;
      // if (0 > intValue) {
      //   this.currentValue = (this.totalInvestmentAmount - this.investedAmount) + intValue;
      // } else {
      //   this.currentValue = (this.totalInvestmentAmount - this.investedAmount) + intValue;

      // }
      this.totalInvestmentAmount = data.row.current_investment_value
        ? data.row.current_investment_value.toFixed(2)
        : 'No data';
      this.netProfitAndLoss = data.row.pnl_value
        ? Number(data.row.pnl_value).toFixed(2)
        : 'No data';
      this.investedAmount = data.row.invested_amount;
      this.withdrawlAmount =
        data.row.withdrawl_amount !== undefined ? data.row.withdrawl_amount : 0;
      this.net_pnl =
        data.row.current_investment_value &&
        data.row.pnl_value &&
        data.row.invested_amount
          ? (
              data.row.current_investment_value +
              this.withdrawlAmount +
              Number(data.row.pnl_value) -
              data.row.invested_amount
            ).toFixed(2)
          : 'No data';
      this.net_profit_percentage =
        data.row.current_investment_value &&
        data.row.pnl_value &&
        data.row.invested_amount
          ? (
              ((data.row.current_investment_value +
                this.withdrawlAmount +
                Number(data.row.pnl_value) -
                data.row.invested_amount) /
                data.row.invested_amount) *
              100
            ).toFixed(2)
          : 'No data';
      const intValue = parseInt(this.netProfitAndLoss, 10);
      if (0 > intValue) {
        this.currentValue =
          this.totalInvestmentAmount - this.investedAmount + intValue;
      } else {
        this.currentValue =
          this.totalInvestmentAmount - this.investedAmount + intValue;
      }
    },
    closeUserDashBoard() {
      this.isUserDashBoard = false;
    },
    rowClick(data) {
      console.log('rowclick', data);
      this.userName = data.row.firstName + ' ' + data.row.lastName;
      this.isUserDashBoard = true;
      this.getListPnL(data);
      this.getData(data);

      // this.$router.push({
      //   name: 'UserDashboard',
      //   params: {
      //     data: data.row,
      //     details: "view",
      //     _id: data.row._id,
      //   },
      //   props: data.row,
      // });
    },
    action(data) {
      this.$router.push({
        name: 'UserDetails',
        params: { _id: data._id },
        props: data,
      });
    },
    // rowClick(data) {
    //   this.$router.push({
    //     name: 'UserDetails',
    //     params: { _id: data.row._id },
    //     props: data.row,
    //   });
    // },
    onLoaded() {
      this.userTable = this.$refs.userTable;
    },
    clearFilter() {
      this.custom_filter_select = '';
    },
    applyFilter(filter_val) {
      Event.$emit('vue-tables.customFilters::custom_filter', filter_val);
    },

    /*download master data */
    exportData() {
      axios({
        method: 'get',
        url: `${Config.serverURI}/v1/exportMaster?model=user`,
        responseType: 'arraybuffer',
      })
        .then(response => {
          console.log('response of download', response);
          const arrayBuffer = response.data;
          const filename = 'Users.xlsx';
          this.downloadFileFromArrayBuffer(arrayBuffer, filename);
        })
        .catch(err => {
          console.log('err', err);
        });
    },

    /*download file */
    downloadFileFromArrayBuffer(arrayBuffer, filename) {
      const url = URL.createObjectURL(
        new Blob([arrayBuffer], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);

      // if (row.reportType == "logbook"){
      //   link.setAttribute('download', filename)
      // }
      // else{
      //   link.setAttribute('download', `${row.stationSiteName}-${row.reportType}.xlsx`)
      // }
      document.body.appendChild(link);
      link.click();
    },
  },
  mounted() {
    eventBus.$on('DATA_PUBLISHED', payload => {
      console.log('askjdajsdh', payload);
    });
    this.getTotalAmount();
  },
};
</script>

<style>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.export-btn {
  position: absolute;
  right: 300px;
  z-index: 1000;
}

.gradientbt {
  background-image: linear-gradient(
    to right,
    rgba(38, 153, 251),
    rgba(146, 205, 255)
  );
  color: white;
}

.total_investment_wrp {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

p {
  font-size: 12px;
  font-weight: bolder;
  line-height: 1;
}

.number {
  font-size: 40px;
}

.panel-footer {
  text-align: center;
}

.bg-primary {
  background-image: linear-gradient(
    to right,
    rgba(38, 153, 251),
    rgba(146, 205, 255)
  );
}

.panel-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 8px;
}

.positive {
  color: green;
}

.negative {
  color: red;
}

.password-popup-width {
  padding-top: 0px;
  background: #fff;
  width: 1080px !important;
  height: 708px !important;
  padding: 20px;
  border-radius: 10px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// Users.vue?59815b85